export const PREVIOUS_STEP =
  'Are you sure you want to move to the previous step?';
export const ACTIVE_STEP = 'Do you want to proceed with the submission?';
